"use strict";
import { useContext } from "react";
import { ShellContext } from "../context";
export function useAnalytics() {
  const { setAnalyticsId } = useContext(ShellContext);
  return setAnalyticsId;
}
